import Close from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import {
  Breakpoint,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@mui/material';

interface DialogConfirmationProps {
  open: boolean;
  handleClose?: () => any;
  title?: string | React.ReactNode;
  content?: string | React.ReactNode;
  acceptButtonTitle?: string;
  cancelButtonTitle?: string;
  acceptButtonHandleClick?: any;
  cancelButtonHandleClick?: any;
  type?: 'success' | 'error';
  acceptButtonProps?: any;
  cancelButtonProps?: any;
  loading?: boolean;
  maxWidth?: false | Breakpoint;
  withClose?: boolean;
  className?: string;
}

export const DialogConfirmation = ({
  open,
  handleClose,
  title,
  content,
  acceptButtonHandleClick,
  acceptButtonTitle,
  cancelButtonHandleClick,
  cancelButtonTitle,
  acceptButtonProps,
  cancelButtonProps,
  type = 'success',
  loading = false,
  maxWidth = 'md',
  withClose = false,
  className = '',
}: DialogConfirmationProps) => {
  return (
    <Dialog className={className} maxWidth={maxWidth} onClose={handleClose} open={open} fullWidth>
      <DialogTitle sx={{ p: 3 }}>{title}</DialogTitle>
      {withClose && (
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <Close />
        </IconButton>
      )}
      <DialogContent>
        {typeof content === 'string' ? <DialogContentText>{content}</DialogContentText> : content}
      </DialogContent>
      <DialogActions>
        {cancelButtonTitle && (
          <Button
            onClick={cancelButtonHandleClick}
            disabled={loading}
            color="inherit"
            size="medium"
            variant="text"
            {...cancelButtonProps}
          >
            {cancelButtonTitle}
          </Button>
        )}
        {acceptButtonTitle && (
          <Button
            onClick={acceptButtonHandleClick}
            loading={loading}
            startIcon={loading && <SaveIcon />}
            loadingPosition={loading ? 'start' : undefined}
            color={type === 'success' ? 'primary' : 'error'}
            variant="contained"
            {...acceptButtonProps}
          >
            {acceptButtonTitle}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
